import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import * as PricelistActions from './pricelist.action';
import { PricelistService } from './pricelist.service';
import { BannerService } from '../../shared/services/banner.service';
import * as PricelistModels from '../../models/pricelist/pricelist';
import { PricelistSearchModel } from '../../models/pricelist/pricelistSearch';
import { HelperService } from '../../../../src/app/services/helper/helper.service';
import { empty } from 'rxjs';
import { saveAs } from 'file-saver';
import * as Models from '../../models/commonModels';

export interface PricelistStateModel {
    List: PricelistModels.PricelistListModel;
    PriceList: Models.Response<PricelistModels.PricelistModel>;
    Search: PricelistSearchModel;
  }

@State<PricelistStateModel>({
    name: 'pricelistState',
    defaults: {
      List: null,
      PriceList: null,
      Search: new PricelistSearchModel()
    }
  })

  @Injectable()

  export class PricelistState {

    constructor(
      private helperService: HelperService,
      private pricelistService: PricelistService,
      private bannerService: BannerService
    ) { }


  @Selector()
  static List(state: PricelistStateModel) {
    return state.List;
  }

  @Selector()
  static PriceList(state: PricelistStateModel) {
    return state.PriceList;
  }

  @Selector()
  static Search(state: PricelistStateModel) {
    return state.Search;
  }

  @Action(PricelistActions.Get)
  Get(
    context: StateContext<PricelistStateModel>,
    action: PricelistActions.Get
  ) {
    context.setState(
      patch({
        PriceList: null
      })
    );

    const errorMessage = 'Błąd pobierania listy cen.';

    this.pricelistService.get(action.PriceListId).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            PriceList: ret
          })
        );
      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('PricelistActions.Get', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(PricelistActions.GetList)
  GetList(
      context: StateContext<PricelistStateModel>,
      action: PricelistActions.GetList
    ) {
      context.setState(
        patch({
          List: null,
        })
      );

      const errorMessage = 'Błąd pobierania listy.';

      this.pricelistService.getList(action.Search).subscribe((ret) => {
        if (ret.Success) {
          context.setState(
            patch({
              List: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },
      (error) => {
        this.helperService.SaveException('PricelistActions.GetPricelist', error);

        this.bannerService.error(errorMessage);
        });
  }

  @Action(PricelistActions.Set)
  Set(
    context: StateContext<PricelistStateModel>,
    action: PricelistActions.Set
  ) {
    const errorMessage = 'Błąd zapisu szczegółów listy cenników.';

    this.pricelistService.set(action.Pricelist).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success(`Zmiany szczegółów cennika ${ret.Item.Label} zapisane.`);

          context.setState(
            patch({
              PriceList: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },

      (error) => {

        this.helperService.SaveException('PricelistActions.Set', error);

        this.bannerService.error(errorMessage);
      },
      () => {});
  }

  @Action(PricelistActions.SetSearch)
  SetSearch(
    context: StateContext<PricelistStateModel>,
    action: PricelistActions.SetSearch
  ) {

    action.Search.CurrentPage = 1;

    context.setState(
      patch({
        Search: action.Search
      }));

    context.dispatch(new PricelistActions.GetList(action.Search));
  }

  @Action(PricelistActions.SetListPage)
  SetListPage(
    context: StateContext<PricelistStateModel>,
    action: PricelistActions.SetListPage
  ) {

    context.getState();
    context.setState(
      patch({
        Search: action.Search
      }));
    context.dispatch(new PricelistActions.GetList(action.Search));
  }


/*  @Action(PricelistActions.ResetSearch)
  resetSearch(
    context: StateContext<PricelistStateModel>
  ) {

    const s = context.getState();

    const search = new PricelistSearchModel();

    search.ItemsPerPage = s.Search.ItemsPerPage;

    context.setState(
      patch({
        Search: search
      }));

    context.dispatch(new PricelistActions.GetList(search));
  }
*/

}
